const actionRef = {
  creation: {
    color: 'green',
    icon: 'fas fa-plus-square',
    label: 'Created'
  },
  update: {
    color: 'yellow',
    icon: 'fas fa-pen',
    label: 'Updated'
  },
  delete: {
    color: 'red',
    icon: 'fas fa-trash',
    label: 'Deleted'
  },
  upload: {
    color: 'cyan',
    icon: 'fas fa-file-upload',
    label: 'Uploaded'
  },
  publish: {
    color: 'blue',
    icon: 'fas fa-cloud-upload-alt',
    label: 'Published'
  },
  download: {
    color: 'purple',
    icon: 'fas fa-download',
    label: 'Downloaded'
  }
}

export const actionIconMixin = {
  methods: {
    actionReference (action) {
      return actionRef[action] || { color: 'grey', icon: '', label: 'Unknown action' }
    },
    actionColor (entry) {
      return this.actionReference(entry.action).color || ''
    },
    actionIcon (entry) {
      return this.actionReference(entry.action).icon || ''
    },
    actionName (entry) {
      return this.actionReference(entry.action).label || ''
    }
  }
}
